import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { ProductDtoAttributes } from "../Product"
import { productQohAdjustment } from "../Types"

export class Service {

    static patch(productId: string, payload: Partial<ProductDtoAttributes>) {
        return AppContext.getApiClient().patch(`/products/${productId}`, payload)
    }

    static generateQohAdjustment(inventoryLocationId: string, productId: string, payload: productQohAdjustment) {
        return AppContext.getApiClient().patch(`/inventory-locations/${inventoryLocationId}/products/${productId}`, payload)
    }
}


// WEBPACK FOOTER //
// ./src/state/product/service/service.ts